module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("5CVhq"))).then(() => parcelRequire('37nVf'));